import { UPDATE_SUBMISSION } from '../ActionTypes'

// Actions
export const updateSubmissionSuccess = data => ({
    type: UPDATE_SUBMISSION,
    payload: {
        submission: data,
        error: false
    }
})